import React, { useEffect, useState } from "react";
import { css } from "@emotion/react";
import { motion, useAnimation } from "framer-motion";
import { useInView } from "react-intersection-observer";
export const fadeInVariants = {
  hidden: { opacity: 0, y: 0 },
  visible: { opacity: 1, y: 0, transition: { duration: 1.5, delay: 0 } },
};

const LoadingIndicator: React.FC = () => {
  const [dots, setDots] = useState("");

  useEffect(() => {
    const interval = setInterval(() => {
      setDots((prev) => (prev.length === 3 ? "" : prev + "."));
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div css={loadingMsgStyle}>
      loading<span css={dotsWrapperStyle}>{dots}</span>
    </div>
  );
};

const loadingMsgStyle = css`
  position: relative;
  color: black;
  font-size: 2rem;

  @media (max-width: 768px) {
    font-size: 1rem;
  }
`;

const dotsWrapperStyle = css`
  position: absolute;
  bottom: 0;
  left: 102%;
`;

type Props = {
  isLoading: boolean;
};

const LoadingModal: React.FC<Props> = (props) => {
  const [ref, inView] = useInView();
  const controls = useAnimation();

  const [isLoaded, setIsLoaded] = useState(false);
  useEffect(() => {
    // preload image
    const img = new Image();
    img.src = process.env.REACT_APP_BASE_PATH + "/img/loading-title.png";
    img.onload = () => {
      console.log("loaded img");
      setIsLoaded(true);
    };

    if (inView) {
      controls.start("visible");
    }
  }, [controls, inView]);

  if (!props.isLoading) {
    return null;
  }
  return (
    <div css={modalStyle}>
      {/* 
      <motion.div
        ref={ref}
        initial="hidden"
        animate={controls}
        variants={fadeInVariants}
      >
        <div
          css={css`
            position: relative;
          `}
        >
          <img
            src={process.env.REACT_APP_BASE_PATH + "/img/loading-title.png"}
            css={titleImgStyle}
          />
          <div css={indicatorContainerStyle}>
            <LoadingIndicator />
          </div>
        </div>
      </motion.div>
      */}
    </div>
  );
};

const spSize = 768;

const modalStyle = css`
  position: fixed;
  z-index: 1000;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: white;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const titleImgStyle = css`
  width: 75px;
  height: auto;

  @media (max-width: ${spSize}px) {
    width: 55px;
  }
`;

const indicatorContainerStyle = css`
  position: absolute;
  top: calc(100% + 40px);
  left: 50%;
  transform: translateX(-50%);

  @media (max-width: ${spSize}px) {
    top: calc(100% + 30px);
  }
`;

export default LoadingModal;
